import AppConfig from '../../global/appConfig';
import gql from 'graphql-tag';
import {client} from "./client";
import {AllEntitiesviewAdmins} from "../../schema/AllEntitiesviewAdmins";
import {AllEntitiesviews} from "../../schema/AllEntitiesviews";
import {Query} from "../../types";

export async function requestGeometryNodes () {
    const isAdmin = AppConfig.isAdmin;
    const queryName = isAdmin ? 'allEntitiesviewAdmins' : 'allEntitiesviews';
    const query = gql`${isAdmin ? AllEntitiesviewAdmins : AllEntitiesviews}`
    try {
        const result: {data: Query} = await client.query({
            query,
        });
        client.cache.reset();
        const data = result.data[queryName]!;
        return data.nodes;
    } catch (e) {
        console.warn(e);
        return [];
    }
}

